import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { ShowcaseLineView } from "./ShowcaseLineView";
import { ShowcaseLineViewStore } from "../../store/ShowcaseLineViewStore";
import { useStore } from "../../../../hooks";

export const ShowcaseLineViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/showcaseLine/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new ShowcaseLineViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <ShowcaseLineView showcaseLineViewStore={store} />
      </PageLayout>
    </div>
  );
});
